export function isEllipsisActive(element: HTMLElement | Element): boolean {
  return element.scrollWidth > element.clientWidth;
}
